import { serviceAPI } from '@/services/services/alertsService';
import BaseModulePlugins from '@/store/baseModule/plugins';
import BaseModule from '@/store/baseModule';

export default (store) => {
  store.registerModule(
    ['properties', 'alerts'],
    new BaseModule({
      serviceAPI,
    })
  );
  const basePlugin = new BaseModulePlugins({
    module: 'properties/alerts',
    store,
  });

  basePlugin.onInit(() => {
    basePlugin.onActiveRequestChange((request) => {
      store.dispatch(`properties/alerts/initCurrent`, request.property_id);
    });
    store.subscribeAction((action) => {
      if (action.type === 'sensors/properties/addCurrent') {
        store.dispatch('properties/alerts/initCurrent', action.payload.id);
      }
    });
  });
};
